/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import { handleAboutToggle, handleFooterAboutMenu, linkToCore } from "./about";
import { handleCarouselMobileHeight } from "./carousel";
import { handleCoreServicesItemHeight } from "./core_services";

jQuery(document).ready(function () {
  // console.info('hello world');

  handleCoreServicesItemHeight();
  handleAboutToggle();
  linkToCore();
  handleFooterAboutMenu();

  handleCarouselMobileHeight();
});
